import React from 'react';
import './Pagination.css';

const Pagination = ({ page, totalPages, handlePageChange }) => (
    <div className="product-directory-pagination">
        <button
            onClick={() => handlePageChange(page - 1)}
            disabled={page === 1}
            className="product-directory-pagination-btn"
        >
            {'<'}
        </button>
        <span className="product-directory-pagination-info">
            Page {page} of {totalPages}
        </span>
        <button
            onClick={() => handlePageChange(page + 1)}
            disabled={page === totalPages}
            className="product-directory-pagination-btn"
        >
            {'>'}
        </button>
    </div>
);

export default Pagination;